/**
 * Traduce un error de axios al mensaje que debe ver el usuario.
 *
 * Prioridad: detalle de validación del backend (`errors[]`) → `message` del
 * backend → falla de red o timeout → `fallback` del contexto. Los errores que no
 * vienen del API (JS, Azure, etc.) usan el `fallback`: su `message` suele ser
 * técnico y en inglés.
 */
export function getErrorMessage(error, fallback = 'Ocurrió un error inesperado. Intenta de nuevo') {
  const response = error?.response

  if (!response) {
    if (error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT') {
      return 'El servidor tardó demasiado en responder. Intenta de nuevo'
    }
    if (error?.isAxiosError) {
      return 'No se pudo conectar con el servidor. Verifica tu conexión a internet'
    }
    return fallback
  }

  const data = response.data

  const details = Array.isArray(data?.errors)
    ? [...new Set(data.errors.map(e => e?.message).filter(Boolean))]
    : []
  if (details.length) return details.join(' · ')

  if (typeof data?.message === 'string' && data.message.trim()) return data.message.trim()
  if (typeof data?.error === 'string' && data.error.trim()) return data.error.trim()

  if (response.status === 403) return 'No tienes permisos para realizar esta acción'

  return fallback
}
